import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex align-items-center justify-content-center bg-neutral-950 color-white",
  style: {"height":"85vh"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = { class: "mb-xl text-5xl text-7xl@xl" }
const _hoisted_4 = { class: "mb-xl text-lg text-3xl@xl" }
const _hoisted_5 = { class: "my-xl" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "color-neutral-600" }, "Error 404", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Grid = _resolveComponent("Grid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Grid, {
      size: "md",
      class: "text-center d-flex flex-column justify-content-between h-full py-8xl"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", null, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.trans("general.are_you_lost")), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.trans("general.it_happens_to_all")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              to: "/",
              color: "light",
              style: {"text-decoration":"none","color":"black"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.trans("general.come_back_to")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_6
      ]),
      _: 1
    })
  ]))
}